import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { Observable } from 'rxjs';
import { SearchRequestType } from '../../models/data/app-core/search-request-type';
import { HttpFactory } from '../../utilities/http-factory';

@Injectable({
    providedIn: 'root'
})

export class SearchRequestService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "searchrequest");
    }

    public getSearchRequestTypes(): Observable<SearchRequestType[] | null> {

        const result = HttpFactory.get<SearchRequestType[]>(this.http, this._controllerName + "/searchrequesttypes", this._apiBaseUrl);

        return result;
    }

    public GetNewEnvelopeBySearchRequestTypeNameAsync(searchRequestTypeName: string, isAdvancedSearch: boolean): Observable<SearchRequestType[] | null> {

        const result = HttpFactory.get<SearchRequestType[]>(this.http, this._controllerName + "/getnewbysearchrequesttypename/" + searchRequestTypeName + "/" + (isAdvancedSearch ? "true" : "false"), this._apiBaseUrl);

        return result;
    }
}
